import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SettingsComponent } from "./settings.component";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "../shared.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { ServiceAccessTableComponent } from "./service-access/service-access-table/service-access-table.component";
import { ServiceAccessModalComponent } from "./service-access/service-access-modal/service-access-modal.component";
import { ServiceAccessCountryModalComponent } from "./service-access-country/service-access-country-modal/service-access-country-modal.component";
import { ServiceAccessCountryTableComponent } from "./service-access-country/service-access-country-table/service-access-country-table.component";
import { RideMarketingTableComponent } from "./marketing-configuration/ride-marketing-table/ride-marketing-table.component";
import { AddRideMarketingComponent } from "./marketing-configuration/add-ride-marketing/add-ride-marketing.component";
import { YachtMarketingTableComponent } from "./marketing-configuration/yacht-marketing-table/yacht-marketing-table.component";
import { AddYachtMarketingComponent } from "./marketing-configuration/add-yacht-marketing/add-yacht-marketing.component";
import { RentalMarketingTableComponent } from "./marketing-configuration/rental-marketing-table/rental-marketing-table.component";
import { AddRentalMarketingComponent } from "./marketing-configuration/add-rental-marketing/add-rental-marketing.component";
import { UberTokenComponent } from "./token/uber-token.component";

const routes: Routes = [
  {
    path: "",
    component: SettingsComponent,
  },
];

@NgModule({
  declarations: [
    SettingsComponent,
    ServiceAccessTableComponent,
    ServiceAccessModalComponent,
    ServiceAccessCountryTableComponent,
    ServiceAccessCountryModalComponent,
    RideMarketingTableComponent,
    AddRideMarketingComponent,
    YachtMarketingTableComponent,
    AddYachtMarketingComponent,
    RentalMarketingTableComponent,
    AddRentalMarketingComponent,
    UberTokenComponent,
  ],
  imports: [CommonModule, SharedModule, NgxSkeletonLoaderModule, RouterModule.forChild(routes)],
})
export class SettingsModule {}
